import { ActionType, createReducer } from "typesafe-actions";
import * as actions from "./actions";
import { LTIState } from "./types";
import initialState from "./state";

type Action = ActionType<typeof actions>;

const reducer = createReducer<LTIState, Action>(initialState)
  .handleAction(actions.addMaterial, (state, { payload }) => {
    const hasSameMaterial = state.selectedMaterials.some(
      ({ id }) => id === payload.material.id,
    );
    const hasDifferentType = state.selectedMaterials.some(
      ({ type }) => type !== payload.material.type,
    );

    if (hasDifferentType) {
      return {
        ...state,
        selectedMaterials: [payload.material],
      };
    }
    return {
      ...state,
      selectedMaterials: hasSameMaterial
        ? state.selectedMaterials
        : [...state.selectedMaterials, payload.material],
    };
  })
  .handleAction(actions.removeMaterial, (state, { payload }) => ({
    ...state,
    selectedMaterials: state.selectedMaterials.filter(
      ({ id }) => id !== payload.id,
    ),
  }))
  .handleAction(actions.clearMaterials, (state) => ({
    ...state,
    selectedMaterials: [],
  }))
  .handleAction(actions.setSearchType, (state, { payload }) => ({
    ...state,
    searchMode: payload || state.searchMode,
  }));

export default reducer;
